import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  Slide,
} from '@mui/material';
import { IAiModel } from '../../api/chat';

interface ModelSelectDialogProps {
  open: boolean;
  onClose: () => void;
  aiModels: IAiModel[] | undefined;
  onSelectModel: (model: IAiModel) => void;
}

function ModelSelectDialog({
  open,
  onClose,
  aiModels,
  onSelectModel,
}: ModelSelectDialogProps) {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      slots={{ transition: Slide }}
      slotProps={{
        transition: {
          direction: 'up',
        },
      }}
      sx={{
        '& .MuiDialog-paper': {
          position: 'fixed',
          bottom: 0,
          margin: 0,
          borderRadius: '16px 16px 0 0',
          maxHeight: '60vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 1,
          fontSize: '1.125rem',
          fontWeight: 600,
        }}
      >
        Select AI Model
      </DialogTitle>
      <DialogContent>
        <List disablePadding>
          {aiModels?.map((model) => (
            <ListItem
              key={model.id}
              onClick={() => onSelectModel(model)}
              sx={{
                cursor: 'pointer',
                borderRadius: 1,
                transition: 'background-color 0.2s',
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
                mb: 1,
                p: 2,
              }}
            >
              <div className="flex items-center gap-3 w-full">
                <img
                  src={model.aiModelProvider.image}
                  alt={model.name}
                  className="w-8 h-8 object-contain"
                />
                <div className="flex flex-col">
                  <span className="font-medium">{model.name}</span>
                  <span className="text-sm text-gray-500">
                    {model.aiModelProvider.name}
                  </span>
                </div>
              </div>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default ModelSelectDialog;
